import { ContentTableItem } from "src/components/ContentTable/ContentTable";

export function mapGroupMembersToContentTableItems(
	members: GroupMember[]
): ContentTableItem[] {
	return members.map((member) => ({
		id: member.userId,
		name: member.name,
		isActive: true,
		data: {
			uuid: member.userId,
			email: member.email,
			role: member.role,
			source: member.source,
			storeName: member.storeName
		}
	}));
}
